const breakpoints = ['35rem', '62rem', '87.5rem']

breakpoints.sm = breakpoints[0]
breakpoints.md = breakpoints[1]
breakpoints.lg = breakpoints[2]

export default breakpoints
